import { graphql } from "relay-runtime"

export const advancedCareProviderSearchFiltersQuery = graphql`
  query useAdvancedCareProviderSearchFiltersQuery($where: CareProviderGroupFilterInput!) {
    careProviderGroups: ch_careProviderGroups(where: $where, first: 100) {
      items: nodes {
        id
        groupType
        translations: careProviderGroupTranslations {
          language
          name
        }
        specialties {
          id
          translations: specialtyTranslations {
            language
            name
          }
          foci {
            id
            translations: focusTranslations {
              language
              name
            }
          }
          specializations {
            id
            translations: specializationTranslations {
              language
              name
            }
          }
        }
        subjectAreas {
          id
          translations: subjectAreaTranslations {
            language
            name
          }
        }
        services {
          id
          translations: servicesTranslations {
            language
            name
          }
        }
      }
    }

    cantons: ch_cantons {
      id
      cantonCode
      translations: cantonTranslations {
        language
        name
      }
    }

    officialLanguages: ch_officialLanguagesLookup {
      id
      isoLanguageCode
      officialLanguageLookupId
      translations: officialLanguageLookupTranslations {
        name: isoLanguageName
        language
      }
    }

    diagnosticFacilities: ch_diagnosticFacilities {
      id
      translations: diagnosticFacilitiesTranslations {
        language
        name
      }
    }

    certificates: ch_certificates {
      id
      translations: certificateTranslations {
        language
        name
      }
    }
  }
`
